import { createFileRoute } from '@tanstack/react-router';

import { ComingSoon } from '@/components/common/ComingSoon';
import * as m from '@/paraglide/messages.js';

export const Route = createFileRoute('/{-$locale}/articles/')({
  component: ArticlesPage,
});

function ArticlesPage() {
  return <ComingSoon title={m.page_articles()} />;
}
